//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            // key: value
        }
    },
    props: {
        list: {
            type: Array,
            default: []
        },
    },
}
